/** @jsx jsx */
import { jsx } from '@emotion/core'
import { HFlow, Icon, Text } from 'bold-ui'
import { resolveName } from 'components/form'
import { MChatPerguntaEnum } from 'graphql/types.generated'
import { useField } from 'react-final-form'
import { MetaPath } from 'util/metaPath'

import { ConsultaSeguimentoSelectionMode } from '../model-consultaSeguimento'
import { getModalFooterCounterText, getPerguntasSelecionadasFieldHasError } from '../utils-consultaSeguimento'

interface ConsultaSeguimentoModalFooterCounterProps {
  name: MetaPath<MChatPerguntaEnum[]>
  selectionMode: ConsultaSeguimentoSelectionMode
  isMChatRiscoBaixo: boolean
  numberOfPerguntasFalhasNoMChat: number
  startFailed: boolean
}

export function ConsultaSeguimentoModalFooterCounter(props: Readonly<ConsultaSeguimentoModalFooterCounterProps>) {
  const { name, selectionMode, isMChatRiscoBaixo, numberOfPerguntasFalhasNoMChat, startFailed } = props

  const {
    input: { value },
    meta,
  } = useField<MChatPerguntaEnum[]>(resolveName(name), {
    subscription: { value: true, error: true, touched: true, dirty: true },
  })

  const hasError = getPerguntasSelecionadasFieldHasError(meta, selectionMode, isMChatRiscoBaixo, startFailed)
  const numberOfPerguntasSelecionadas = value?.length

  const numberOfPerguntas =
    selectionMode === ConsultaSeguimentoSelectionMode.AUTOMATICO
      ? numberOfPerguntasFalhasNoMChat
      : numberOfPerguntasSelecionadas

  const hasPerguntasSelecionadas = numberOfPerguntas > 0

  const text = getModalFooterCounterText(numberOfPerguntas, hasError)

  return (
    <HFlow alignItems='center' hSpacing={0.5}>
      {hasError && <Icon size={1} icon='banOutline' fill='danger' />}
      <Text color={hasError ? 'danger' : 'inherit'}>
        <strong>{hasPerguntasSelecionadas && numberOfPerguntas}</strong> {text}
      </Text>
    </HFlow>
  )
}
